export default {
  userProfile: {
    persoProTitle: 'Type de profil',
    personnal: 'Particulier',
    professional: 'Professionel',
    add_logo: 'Ajouter un logo',
    intro: 'Vos données seront utilisées uniquement pour personnaliser la génération des documents de vos calculs',
    ALERT_LOGO_MISSING: "Aucun logo n'a été trouvé sur votre profil utilisateur. Souhaitez-vous définir votre logo ?"
  },
  deleteUser: {
    title: 'Supprimer votre compte',
    question: 'Vous êtes sur le point de supprimer votre compte sur BatiKal. Êtes vous sûr(e) de votre choix ?',
    body: "Cette opération entrainera la suppression des activités que vous avez réalisées sur l'application et celle-ci est irreversible. Si vous avez un compte premium, il est préférable de le désactiver avant de supprimer votre compte.",
    checkBox1: 'Vous souhaitez la suppression de votre profil BatiKal',
    checkBox2: 'Vous êtes conscient que cette action est irréversible',
    cancel: 'Annuler',
    delete: 'Supprimer'
  }
}
